import React from 'react';
import { Field, useFormikContext } from 'formik';

import { FormErrorUI, FormLabelUI, AutoCompleteSelectUI, CheckboxUI } from '../Interface';

const FinancialSettingFields = ({ viewField, autoCompleteOptions }) => {
  const { values, errors, setFieldValue, validateField } = useFormikContext();

  return (
    <div className="grid grid-cols-4 gap-x-4 mx-4 mb-5">
      <div className="col-span-2 md:col-span-1">
        <Field
          type="autocomplete"
          name="purchaseVatCodeItem"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Beszerzés alapértelmezett ÁFA kód cikkek" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.purchaseVatCodeItem} />}
          onChange={(_e, newVal) => {
            setFieldValue('purchaseVatCodeItem', newVal?.value ?? null).then(() => {
              validateField('purchaseVatCodeItem');
            });
          }}
          disabled={viewField}
          InputLabelProps={{ shrink: values.purchaseVatCodeItem !== null }}
          selectedValue={values.purchaseVatCodeItem}
          selectedLabelValue={
            autoCompleteOptions?.purchaseVatCodeItem?.find((opt) => opt.value === values.purchaseVatCodeItem)?.name
          }
          dataset={autoCompleteOptions?.purchaseVatCodeItem}
        />
      </div>
      <div className="col-span-4 md:col-span-1">
        <Field
          type="autocomplete"
          name="purchaseVatCodeService"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Beszerzés alapértelmezett ÁFA kód szolgáltatások" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.purchaseVatCodeService} />}
          onChange={(_e, newVal) => {
            setFieldValue('purchaseVatCodeService', newVal?.value ?? null).then(() => {
              validateField('purchaseVatCodeService');
            });
          }}
          disabled={viewField}
          InputLabelProps={{ shrink: values.purchaseVatCodeService !== null }}
          selectedValue={values.purchaseVatCodeService}
          selectedLabelValue={
            autoCompleteOptions?.purchaseVatCodeService?.find((opt) => opt.value === values.purchaseVatCodeService)
              ?.name
          }
          dataset={autoCompleteOptions?.purchaseVatCodeService}
        />
      </div>
      <div className="col-span-2 md:col-span-1">
        <Field
          type="autocomplete"
          name="salesVatCodeItem"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Értékesítés alapértelmezett ÁFA kód cikkek" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.salesVatCodeItem} />}
          onChange={(_e, newVal) => {
            setFieldValue('salesVatCodeItem', newVal?.value ?? null).then(() => {
              validateField('salesVatCodeItem');
            });
          }}
          disabled={viewField}
          InputLabelProps={{ shrink: values.salesVatCodeItem !== null }}
          selectedValue={values.salesVatCodeItem}
          selectedLabelValue={
            autoCompleteOptions?.salesVatCodeItem?.find((opt) => opt.value === values.salesVatCodeItem)?.name
          }
          dataset={autoCompleteOptions?.salesVatCodeItem}
        />
      </div>
      <div className="col-span-4 md:col-span-1">
        <Field
          type="autocomplete"
          name="salesVatCodeService"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Értékesítés alapértelmezett ÁFA kód szolgáltatások" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.salesVatCodeService} />}
          onChange={(_e, newVal) => {
            setFieldValue('salesVatCodeService', newVal?.value ?? null).then(() => {
              validateField('salesVatCodeService');
            });
          }}
          disabled={viewField}
          InputLabelProps={{ shrink: values.salesVatCodeService !== null }}
          selectedValue={values.salesVatCodeService}
          selectedLabelValue={
            autoCompleteOptions?.salesVatCodeService?.find((opt) => opt.value === values.salesVatCodeService)?.name
          }
          dataset={autoCompleteOptions?.salesVatCodeService}
        />
      </div>
      <div className="col-span-4 md:col-span-2">
        <Field
          name="issuedInvoiceJokerFieldsEditable"
          type="checkbox"
          as={CheckboxUI}
          fullWidth
          label={<FormLabelUI text="Joker mezők módosíthatók a kiállított számlán" />}
          disabled={viewField}
        />
      </div>
      <div className="col-span-4 md:col-span-2">
        <Field
          name="issuedInvoiceProjectCostCenterInternalNoteEditable"
          type="checkbox"
          as={CheckboxUI}
          fullWidth
          label={<FormLabelUI text="Projekt, költséghely, belső megjegyzés módosítható a kiállított számlán" />}
          disabled={viewField}
        />
      </div>
    </div>
  );
};

export default FinancialSettingFields;
